export default __webpack_public_path__ + "static/media/back.16a5ff3a.svg";